import { createAgreementsResource } from './resources/agreements.js';
import { createAnalyticsResource } from './resources/analytics.js';
import { createAuditEventsResource } from './resources/audit-events.js';
import { createAuthResource } from './resources/auth.js';
import { createBadgePrintRecordsResource, } from './resources/badge-print-records.js';
import { createBadgePrintersResource, } from './resources/badge-printers.js';
import { createBadgeTemplatesResource, } from './resources/badge-templates.js';
import { createLocationNotificationRecipientsResource, } from './resources/location-notification-recipients.js';
import { createTenantEmailDomainsResource } from './resources/tenant-email-domains.js';
import { createBillingResource } from './resources/billing.js';
import { createBrandingResource } from './resources/branding.js';
import { createKioskSettingsResource } from './resources/kiosk-settings.js';
import { createDepartmentsResource } from './resources/departments.js';
import { createEmployeeDirectoryResource, } from './resources/employee-directory.js';
import { createDevicesResource } from './resources/devices.js';
import { createEvacuationResource } from './resources/evacuation.js';
import { createFlowsResource } from './resources/flows.js';
import { createHealthResource } from './resources/health.js';
import { createInvitesResource } from './resources/invites.js';
import { createVisitPassResource } from './resources/visit-pass.js';
import { createLocationsResource } from './resources/locations.js';
import { createMembersResource } from './resources/members.js';
import { createMembershipsResource, } from './resources/memberships.js';
import { createOnboardingResource } from './resources/onboarding.js';
import { createNotificationSettingsResource, } from './resources/notification-settings.js';
import { createDirectorySyncResource } from './resources/directory-sync.js';
import { createFederationResource } from './resources/federation.js';
import { createSsoResource } from './resources/sso.js';
import { createIntegrationsResource } from './resources/integrations.js';
import { createPrivacySettingsResource, } from './resources/privacy-settings.js';
import { createPartnerAuthResource } from './resources/partner-auth.js';
import { createPartnerPortalResource } from './resources/partner-portal.js';
import { createPartnersResource, createTenantPartnerResource, } from './resources/partners.js';
import { createSetupSessionsResource } from './resources/setup-sessions.js';
import { createPeopleResource } from './resources/people.js';
import { createRetentionSettingsResource, } from './resources/retention-settings.js';
import { createControlTowerResource } from './resources/control-tower.js';
import { createTenantsResource } from './resources/tenants.js';
import { createVisitorTypesResource, } from './resources/visitor-types.js';
import { createVisitsResource } from './resources/visits.js';
import { createTransport } from './transport.js';
export function createClient(options) {
    const transport = createTransport(options);
    return {
        agreements: createAgreementsResource(transport),
        analytics: createAnalyticsResource(transport),
        auditEvents: createAuditEventsResource(transport),
        auth: createAuthResource(transport),
        billing: createBillingResource(transport),
        branding: createBrandingResource(transport),
        kioskSettings: createKioskSettingsResource(transport),
        members: createMembersResource(transport),
        memberships: createMembershipsResource(transport),
        tenants: createTenantsResource(transport),
        controlTower: createControlTowerResource(transport),
        locations: createLocationsResource(transport),
        departments: createDepartmentsResource(transport),
        employeeDirectory: createEmployeeDirectoryResource(transport),
        people: createPeopleResource(transport),
        devices: createDevicesResource(transport),
        flows: createFlowsResource(transport),
        visitorTypes: createVisitorTypesResource(transport),
        visits: createVisitsResource(transport),
        evacuation: createEvacuationResource(transport),
        health: createHealthResource(transport),
        invites: createInvitesResource(transport),
        visitPass: createVisitPassResource(transport),
        notificationSettings: createNotificationSettingsResource(transport),
        privacySettings: createPrivacySettingsResource(transport),
        partners: createPartnersResource(transport),
        tenantPartner: createTenantPartnerResource(transport),
        partnerAuth: createPartnerAuthResource(transport),
        partnerPortal: createPartnerPortalResource(transport),
        setupSessions: createSetupSessionsResource(transport),
        integrations: createIntegrationsResource(transport),
        directorySync: createDirectorySyncResource(transport),
        federation: createFederationResource(transport),
        sso: createSsoResource(transport),
        onboarding: createOnboardingResource(transport),
        retentionSettings: createRetentionSettingsResource(transport),
        badgePrintRecords: createBadgePrintRecordsResource(transport),
        badgePrinters: createBadgePrintersResource(transport),
        badgeTemplates: createBadgeTemplatesResource(transport),
        tenantEmailDomains: createTenantEmailDomainsResource(transport),
        locationNotificationRecipients: createLocationNotificationRecipientsResource(transport),
        transport,
    };
}
//# sourceMappingURL=client.js.map